import httpManager from "@/app/shared/utils/httpManager";

/**
 * Calls backend to validate if an application name is available.
 * Used in form validation before creating a new application.
 */
export async function validateAccountName(name: string) {
  const url = `/channels/gupshup-waba/validate-name/`;
  const response = await httpManager.post(url, { name });
  return response?.data;
}